import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import type { FeatureFlag } from "../types/featureFlags.types";
import {
  useFeatureFlag,
  useFeatureFlagStore,
} from "../store/useFeatureFlagStore";

/** Renders children only when the flag is on. */
export function FeatureGate({
  flag,
  children,
}: {
  flag: FeatureFlag;
  children: ReactNode;
}) {
  return useFeatureFlag(flag) ? <>{children}</> : null;
}

/** Route wrapper: renders nothing until flags settle, then redirects home if the flag is off. */
export function FeatureRoute({
  flag,
  children,
}: {
  flag: FeatureFlag;
  children: ReactNode;
}) {
  const enabled = useFeatureFlag(flag);
  const ready = useFeatureFlagStore((s) => s.ready);
  if (!ready) return null;
  return enabled ? <>{children}</> : <Navigate to="/" replace />;
}
